import { ThunkDispatch } from 'redux-thunk';

import { Environment } from 'dashboard/models/environment';
import { setCurrentEnvironment } from 'dashboard/redux/actions/current-environment';
import StorageClient, { LocalStorageKey } from 'lib/clients/StorageClient';

export function setAndPersistCurrentEnvironment(currentEnvironment: Environment) {
  return (dispatch: ThunkDispatch<any, any, any>) => {
    StorageClient.setLocalItem(
      LocalStorageKey.DashboardCurrentEnvironmentId,
      currentEnvironment?.id,
    );
    dispatch(setCurrentEnvironment(currentEnvironment));
  };
}
